var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { nl2br, targetBlankifyLinks } from '../../../lib/helpers';
import { strings } from '../../../lib/localization';
import { ErrorMsg } from '../../error-msg';
export var StarRatingField = function (_a) {
    var data = _a.data, value = _a.value, inputValueChange = _a.inputValueChange;
    var onChange = function (e) {
        inputValueChange(data.qid, 'textInput', e.target.value);
    };
    var handleKeyDown = function (e, rating) {
        if (e.key === ' ') {
            e.preventDefault();
            inputValueChange(data.qid, 'textInput', rating);
        }
    };
    var labelHtml = {
        __html: nl2br(targetBlankifyLinks(data.label)),
    };
    var labelId = "radio-group-".concat(data.qid);
    return (_jsx("div", __assign({ className: data.className ? data.className : 'col-xs-12' }, { children: _jsxs("div", __assign({ className: 'input-line input-rating', role: "radiogroup", "aria-required": data.required, "aria-labelledby": labelId }, { children: [data.label && (_jsxs("label", __assign({ dir: "auto" }, { children: [_jsx("span", { id: labelId, dangerouslySetInnerHTML: labelHtml }, void 0), _jsx("span", __assign({ className: "fieldRequired" }, { children: data.required && '*' }), void 0)] }), void 0)), _jsx("div", __assign({ className: "npsRatingContent" }, { children: [10, 9, 8, 7, 6, 5, 4, 3, 2, 1].map(function (nr) { return [
                        _jsx("input", { type: "radio", id: "stars-".concat(data.qid, "-").concat(nr), name: "rating-".concat(data.qid), onChange: onChange, value: nr, checked: value.value === String(nr) }, 'radio' + nr),
                        _jsx("label", { className: nr % 2 !== 0 ? 'half' : 'full', htmlFor: "stars-".concat(data.qid, "-").concat(nr), role: "radio", "aria-label": strings.formatString(strings.a11yRadioStar, {
                                number: nr,
                            }), "aria-checked": value.value === String(nr), tabIndex: 0, onKeyDown: function (e) { return handleKeyDown(e, String(nr)); } }, 'label' + nr),
                    ]; }) }), void 0), data.errorMessage && (_jsx(ErrorMsg, { id: data.qid, error: data.errorMessage }, void 0))] }), void 0) }), data.qid));
};
